import { CrmApiRepository, fetchAllPages } from './CrmApiRepository.js';
import { CacheService } from '../CacheService.js';
import { mapUserFromApi } from './ApiEntityMapper.js';
import { auth } from '../AuthService.js';

export class ApiModeDataService {
    static async getClientsAll() {
        return CrmApiRepository.getAllClients();
    }

    static async getContactsAll() {
        return CrmApiRepository.getAllContacts();
    }

    static async getDealsAll() {
        return CrmApiRepository.getAllDeals();
    }

    static async getSchedulesForDeal(dealId) {
        return CrmApiRepository.getSchedulesByDeal(dealId);
    }

    static async getEnrichedDeals() {
        const userId = auth.getSession()?.userId || 'anon';
        const cacheKey = `deals:enriched:all:${userId}`;
        return CacheService.getOrSet(cacheKey, async () => {
            const [deals, clients, contacts, users] = await Promise.all([
                CrmApiRepository.getAllDeals(),
                CrmApiRepository.getAllClients(),
                CrmApiRepository.getAllContacts(),
                fetchAllPages('/api/v1/users').then(rows => rows.map(mapUserFromApi))
            ]);

            const clientMap = Object.fromEntries(clients.map(c => [c.id, c]));
            const userMap = Object.fromEntries(users.map(u => [u.id, u]));

            return deals.map(d => {
                const client = clientMap[d.clientId];
                const owner = userMap[d.ownerUserId];
                const creator = userMap[d.createdBy];
                const updater = userMap[d.updatedBy];

                const dealAmount = d.contractValue || d.amount || 0;

                return {
                    ...d,
                    dealName: d.dealName || d.name,
                    accountName: client?.name || '',
                    clientName: client?.name || '',
                    dealOwner: owner?.name || '—',
                    ownerName: owner?.name || '—',
                    createdByName: creator?.name || '—',
                    updatedByName: updater?.name || '—',
                    dealAmount,
                    amount: dealAmount
                };
            });
        }, 1 * 60 * 1000);
    }
}
